export default __webpack_public_path__ + "static/media/elements-filled.0d519bc3.svg";